import { createLogger } from "@/lib/observability/logger";
import loadPlacesLibrary from "../common/load-places-library";

// getPostalCodePredictions gets postal code predictions from the Google Maps API
export default async function getPostalCodePredictions(
  postalCode: string,
): Promise<google.maps.places.PlacePrediction[]> {
  const logger = createLogger("getPostalCodePredictions");
  if (!postalCode) return [];

  try {
    const { AutocompleteSuggestion } = await loadPlacesLibrary();

    const autocompleteResponse =
      await AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: postalCode,
        includedPrimaryTypes: ["postal_code"],
      });

    return autocompleteResponse.suggestions
      .map((suggestion) => suggestion.placePrediction)
      .filter(
        (prediction): prediction is google.maps.places.PlacePrediction =>
          prediction !== null,
      );
  } catch (error) {
    logger.logError("getPostalCodePredictions", error as Error);
    throw new Error("Unable to search postal codes. Please try again.");
  }
}
